import {
  ButtonNextDriver,
  buttonNextDriverFactory,
} from '../internal/WixUiCoreComponents/components/CoreButtonNext/CoreButtonNext.uni.driver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface ButtonDriver extends ButtonNextDriver {
  isFullWidth(): Promise<boolean>;
  isMobile(): Promise<boolean>;
}

export const buttonDriverFactory = (base: UniDriver): ButtonDriver => {
  return {
    ...buttonNextDriverFactory(base),
    isFullWidth: async () => {
      const attr = await base.attr('data-fullwidth');
      return attr === 'true';
    },
    isMobile: async () => {
      const attr = await base.attr('data-mobile');
      return attr === 'true';
    },
  };
};
